import React, { useState } from 'react';
import classes from './base-error-boundary.module.scss';

type CommItErrorScreenProps = {
  title?: string;
  body?: string;
};

// Architectural summary: shared crash surface for both error boundaries — the CommItLoader
// assembly frozen mid-sequence. Copy is generic on purpose; the real error goes to reportError.
export const CommItErrorScreen: React.FC<CommItErrorScreenProps> = ({
  title = 'הטעינה נעצרה באמצע',
  body = 'הנתונים לא הגיעו מהשרת. ברוב המקרים רענון של המסך מסדיר את זה.',
}) => {
  // Frozen at mount so the operator reports when it broke, not when they read it.
  const [failedAt] = useState(() =>
    new Date().toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' }));

  return (
    <div className={classes.root} dir="rtl">
      <div className={classes.panel} role="alert" data-testid="app-error-screen">
        <div className={classes.word} aria-label="CommitAI">
          <span className={classes.comm} aria-hidden="true">Comm</span>
          <span className={classes.seam} aria-hidden="true" />
          <span className={classes.it} aria-hidden="true">it</span>
          <span className={classes.ai} aria-hidden="true">AI</span>
          <span className={classes.line} aria-hidden="true" />
        </div>

        <h1 className={classes.title}>{title}</h1>
        <p className={classes.body}>{body}</p>

        <div className={classes.actions}>
          <button
            type="button"
            className={classes.button}
            data-testid="app-error-reload"
            onClick={() => window.location.reload()}
          >
            טעינה מחדש
          </button>
          <a className={classes.link} href="/">חזרה למסך הראשי</a>
        </div>

        <p className={classes.meta}>
          אם המסך חוזר שוב, צלמו אותו ושלחו לתמיכה יחד עם השעה: <time>{failedAt}</time>
        </p>
      </div>
    </div>
  );
};
